import {HttpClient, HttpStatusCode} from 'data/protocols/http';
import {APIError} from 'data/errors/api-error';
import {
	PostDeclineWellBornProgram,
	PostDeclineWellBornProgramResponse,
} from 'domain/usecases/private/well-born/post-decline-well-born-program';

export class RemoteDeclineWellBornProgram implements PostDeclineWellBornProgram {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<PostDeclineWellBornProgramResponse>,
	) {}

	async decline(): Promise<PostDeclineWellBornProgramResponse> {
		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'post',
		});

		switch (httpResponse.status) {
			case HttpStatusCode.ok:
				return httpResponse.data;
			case HttpStatusCode.created:
				return httpResponse.data;
			case HttpStatusCode.noContent:
				return httpResponse.data;
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
